import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function trimWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const isValid = typeof value === 'string' ? value.trim().length > 0 : value != null;
    return isValid ? null : { trimWhitespace: { actual: value } };
  };
}
